<template>
    <div class="grouped-list">
        <div class="__inner" :class="{'dropdown':isDropdown}">
					<div class="dropdown_header" v-if="selectStep === 2">
						<a class="all_options" @click="selectStep = 1">
							<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M5.35352 1.35352L4.64652 0.646514L0.293015 5.00002L4.64652 9.35352L5.35352 8.64652L1.70701 5.00002L5.35352 1.35352Z" fill="#4368E0"/>
							</svg>
							{{ allOptions || 'All options' }}
						</a>
						<span class="separator">/</span>
						<b class="__name">{{options[selectedIndex].name}}</b>
					</div>
					<ul v-if="selectStep === 1">
						<li v-for="(item, index) in options">
							<a @click="selectOptionFirst(index, item)">
								{{item.name}}
								<span class="layout-row flex-center">
								<span class="__option-tag">
									{{item.options ? item.options.length : '0'}}
								</span>
								<svg style="margin-left: 8px;" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M0.646484 1.35352L1.35348 0.646514L5.70699 5.00002L1.35348 9.35352L0.646484 8.64652L4.29299 5.00002L0.646484 1.35352Z" fill="#C5C7D2"/>
								</svg>
								</span>
							</a>
						</li>
					</ul>
					<ul v-if="selectStep === 2">
						<li v-for="(item, index) in options[selectedIndex].options">
							<a @click="selectOption(item)">
								{{item.name}}
								<span class="__option-tag" v-if="item.tag">
									{{item.tag}}
								</span>
							</a>
						</li>
					</ul>
        </div>
    </div>
</template>

<script>
import API from "@/api"

export default {
	name: "GroupedList",
	mixins: [API],
	props: ['options', 'selectedItem', 'allOptions','isDropdown'],
	data: () => ({
		selected: '',
		dropdownOpen: false,
		selectStep: 1,
		selectedIndex: 0,
		selectedParent: {}
	}),
	computed: {
		selectedText(){
			return this.selected.length ? this.selected : 'Select a condition'
		}
	},
	watch:{
		// options(val){
		// 	if(val){
		// 		this.searchSelected();
		// 	}
		// }
	},
	methods: {
		selectOptionFirst(indx, item) {
			this.selectStep = 2;
			this.selectedIndex = indx;
			this.selectedParent = item;
		},
		selectOption(item){
			this.dropdownOpen = false;
			this.selectStep = 1;

			this.selected = item.name;

			// send full selected item, to get item.operands from it.
      this.$emit('change', {field: this.selectedParent.id + '.' + item.id, item: item});
		},
		dropdownClickOutside(e){
			if(!e.target.classList.contains('trigger') && !e.target.classList.contains('all_options')) {
				this.dropdownOpen = false;
				this.selectStep = 1;
			}
		},
		// searchSelected(){
		// 	if(this.selectedItem.length > 0){
		// 		var beforeDot = this.selectedItem.split('.')[0];
		// 		var afterDot = this.selectedItem.split('.')[1];
		//
		// 		var findCondition = this.options.filter(item => item.id.toLowerCase().includes(beforeDot.toLowerCase()))[0];
		// 		if (!findCondition) return ;
		// 		var findOption = findCondition.options.filter(item => item.id.toLowerCase().includes(afterDot.toLowerCase()))[0];
		//
		// 		if (!findOption) return;
		// 		this.selected = findOption.name;
		//
    //     this.$emit('change', {field: this.selectedItem, item: findOption});
    //   }
		// }
	},
	beforeMount(){

	}
};
</script>

<style lang="scss" scoped>
	.grouped-list {
		width: 100%;
		position: relative;
		padding: 5px;

		.__name {
			display: block;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.trigger {
			background: #FFFFFF;
			border-radius: 6px;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 11px 15px;
			letter-spacing: 0.02em;
			font-size: 14px;
			color: #C5C7D2;
			box-shadow: 0 0 0px 1px rgb(198, 199, 210);
			cursor: pointer;
			&.option_selected {
				color: #252A32;
			}
		}
		.__option-tag {
			border-radius: 15px;
			background: $light-grey;
			padding: 2px 8px;
			height: fit-content;
			display: block;
			min-width: 24px;
			font-size: 11px;
			margin-left: 5px;
			text-align: center;
		}
	}
	.__inner {
		ul {
			max-height: 200px;
			overflow-y: auto;
			li a {
				font-style: normal;
				font-weight: normal;
				font-size: 13px;
				line-height: 150%;
				letter-spacing: 0.02em;
				color: #636A7B;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 5px 15px;
				border-radius: 4px;
			}
		}
		ul li a:hover {
			background: #F6F9FE;
			color: #252A32;
		}
		ul li a:hover svg path {
			fill: #252A32;
		}
	}
	.dropdown {
		//position: fixed;
		//z-index: 9999;
		width: 100%;
		background: #FFFFFF;
		border: 1px solid #E4E6F1;
		box-shadow: 0px 64px 64px rgba(211, 214, 215, 0.2), 0px 32px 32px rgba(211, 214, 215, 0.2), 0px 16px 16px rgba(211, 214, 215, 0.2), 0px 4px 4px rgba(211, 214, 215, 0.2), 0px 2px 2px rgba(211, 214, 215, 0.2);
		border-radius: 6px;
		padding: 15px;
	}
	.dropdown_header {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		border-bottom: 1px solid #EBEFF6;
		padding: 10px 5px;
		margin-bottom: 5px;
		white-space: nowrap;
		a {
			display: flex;
			align-items: center;
			svg {
				margin-right: 10px;
			}
		}
		.separator {
			margin: 0 5px;
		}
	}
	.dropdown_header a:hover {
		color: #4368E0;
	}
	.dropdown_header a:hover svg path {
		fill: #4368E0;
	}
</style>
